import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Button, Collapse, List, Input, Table} from 'antd'
import $ from 'jquery'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'
import {toJS} from 'mobx'

const {TextArea} = Input
const {Panel} = Collapse

@inject('mappingManagementStore')
@observer
class FormModalRules extends Component {
  state = {
    editorState: '',
    filtersIndex: null,
    filtersList: [],
    // defaultInfos: [
    //   {
    //     explain: 'Constant Value.',
    //     examples: '\'KU\'',
    //   },
    //   {
    //     explain: 'Direct assignment.',
    //     examples: '$customerPONo',
    //   },
    //   {
    //     explain: 'Convert to date format.',
    //     examples: 'date_format(to_timestamp($customerPODate,\'yyyy-MM-dd\'),\'yyyyMMdd\')',
    //   },
    //   {
    //     explain: 'When the target structure is an array, needed to build.',
    //     examples: 'array(\'0002\',\'Z019\'),array($poInstruction,$vendorNumberGLN)',
    //   },
    //   {
    //     explain: 'This is used when the target structure has more than one item and needs to be marked as the number of items.',
    //     examples: 'sequence(1,size($items))',
    //   },
    //
    //
    //   {
    //     explain: 'When the source structure and the target have multiple Items (the structure is an array), the Transform is used to traverse.',
    //     examples: 'TRANSFORM($items.custMaterialCode,x-> x)',
    //   },
    //   {
    //     explain: 'Filter is used when the target type is simply a String, and the source type is an array, and certain conditions are applied to obtain the corresponding value.',
    //     examples: 'FILTER($documentReference,x -> x[\'referenceType\'] == \'CustPONO\')[0].referenceNumber',
    //   },
    //   {
    //     explain: 'The example is a combination of Date Formation + Filter.',
    //     examples: 'date_format(to_timestamp(FILTER($documentReference.referenceDateAndTime,x -> x[\'type\'] == \'CustPODate\')[0].date,\'yyyyMMdd\'),\'yyyy-MM-dd\')',
    //   },
    //   {
    //     explain: 'For example, it is used when the source type is String and the target type is Double.',
    //     examples: 'cast($quantity as double)',
    //   },
    //   {
    //     explain: 'Can be used when the source structure and target structure are both arrays and there are certain filter conditions.',
    //     examples: 'TRANSFORM($orderItem,x -> IF(x[\'quantity\'][\'quantityType\'] == \'ConfirmedQTY\',cast(x[\'quantity\'][\'quantity\'] as double),null))',
    //   },
    //   {
    //     explain: 'Concatenation of string.',
    //     examples: 'concat($data.REFSHEETID,\'WS\'),concat($data.REFSHEETID,$data.REFSHEETID)',
    //   },
    //   {
    //     explain: '',
    //     examples: 'case when $data.NOTE like \'%团购%\' then concat($data.REFSHEETID,\'WS\') else concat($data.REFSHEETID,\'XD\') end',
    //   },
    //   {
    //     explain: 'Addition.',
    //     examples: '$COST+$PKGVOLUME',
    //   },
    //   {
    //     explain: 'Subtraction.',
    //     examples: '$COST-$PKGVOLUME',
    //   },
    //   {
    //     explain: 'Multiplication.',
    //     examples: '$COST*$PKGVOLUME',
    //   },
    //
    //
    //   {
    //     explain: 'Division.',
    //     examples: '$COST/$PKGVOLUME',
    //   },
    //   {
    //     explain: 'Keep two decimals.',
    //     examples: 'round($COST*$PKGVOLUME,2)',
    //   },
    //   {
    //     explain: 'The example is a combination of Date Formation + multiplication.',
    //     examples: 'TRANSFORM($data.sku,x-> round(x[\'COST\']*x[\'PKGVOLUME\'],2))',
    //   },
    //   {
    //     explain: 'The example is a combination of Date Formation + division.',
    //     examples: 'TRANSFORM($data.sku,x-> round(x[\'COST\']/1.13,2))',
    //   },
    //   {
    //     explain: 'The first param is external table name, the second param is lookup condition, the third param is the lookup field name',
    //     examples: 'external_table_lookup(\'PG_HR_MD_MAPPING_CRV\',\'$data.VENDERID == PG_HR_MD_MAPPING_CRV.VENDERID and $data.DESTSHOPID == PG_HR_MD_MAPPING_CRV.MD_DC_BH\',\'Customer_GLN\')"',
    //   },
    //
    //
    //   {
    //     explain: 'Check the date format.',
    //     examples: 'date_check($data.c1,\'YYYY-MM-dd\')',
    //   },
    //   {
    //     explain: 'Check the value format.',
    //     examples: 'value_check($data.c1,\'NUMBER\')',
    //   },
    //   {
    //     explain: 'The first argument is the field, the second is the string or regular that needs to be replaced, and the third is what.',
    //     examples: 'regexp_replace($data.c1,\'12\',\'aa\')',
    //   },
    //   {
    //     explain: '等于',
    //     examples: '$customerOrderType == \'BW\'',
    //   },
    //   {
    //     explain: '不等于',
    //     examples: '$customerOrderType != \'BW\'',
    //   },
    //   {
    //     explain: '大于',
    //     examples: '$customerOrderType > \'BW\'',
    //   },
    //   {
    //     explain: '大于等于',
    //     examples: '$customerOrderType >= \'BW\'',
    //   },
    //   {
    //     explain: '小于',
    //     examples: '$customerOrderType < \'BW\'',
    //   },
    //   {
    //     explain: '小于等于',
    //     examples: '$customerOrderType <= \'BW\'',
    //   },
    //   {
    //     explain: 'A field is used to get the pk value of the record, this method is only supported for fields at root level or only in Struct.',
    //     examples: 'get_record_primary_key()',
    //   },
    //   {
    //     explain: 'This function is used to gather the input list, with a total of 4 parameters, the last one optional.',
    //     examples: '1 aggregate(expr, start, merge, finish); '+ ' \n ' +
    //       '2 aggregate(array(1, 2, 3), 0, (acc, x) -> acc + x); output: 6; '+ ' \n ' +
    //       '3 aggregate(array(1, 2, 3), 0, (acc, x) -> acc + x, acc -> acc * 10); 60.',
    //   },
    //   // {
    //   //   explain: '',
    //   //   examples: '',
    //   // },
    // ]
  }
  formRef = React.createRef()

  componentDidMount() {
    const {mappingManagementStore, rulesIndex, rulesType} = this.props
    const {fieldDataSource, filtersDataSource, preProcessingDataSource} = mappingManagementStore
    var defaultFiltersList = []
    defaultFiltersList = rulesType === 1 ? preProcessingDataSource : rulesType === 2 ? filtersDataSource : null
    this.setState({
      editorState: rulesIndex !== '' ? fieldDataSource[rulesIndex].computationExpression : '',
    })
    this.setState({
      filtersList: defaultFiltersList
    })
    this.formRef.current.setFieldsValue({
      editorState: rulesIndex !== '' ? fieldDataSource[rulesIndex].computationExpression : '',
    })
  }

  /*BraftEditor onChange*/
  handleChange = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({
        editorState: fieldsValue.editorState
      })
    }).catch(err => {})
  }
  /*save*/
  handleOk = () => {
    const {mappingManagementStore, handleCancelRules, rulesIndex, rulesType} = this.props
    const {inboundListRules, inboundListDefault} = mappingManagementStore
    if (rulesIndex !== '') {
      var params = []
      var checkParams = []
      var diffParams = []
      var checkArr = []
      params = this.state.editorState
      if (params.match(/\$[\w|.//]+/g) !== null) {
        checkParams = JSON.parse(JSON.stringify(params.match(/\$[\w|//]+/g))?.replace(/\$/g, ''))
        checkParams.reduce((arr, item) => {
          !inboundListRules.includes(item) && diffParams.push(item)
          return diffParams
        }, [])
        if (diffParams.length > 0) {
          alertMessage.error('Failed！The following fields do not exist![' + diffParams + ']')
        } else {
          for (let i = 0; i < checkParams.length; i++) {
            inboundListDefault.filter(item => item.path === checkParams[i]).map(it => {
              delete it.children
              return checkArr.push(it)
            })
          }
          mappingManagementStore.onChangeRulesDataSource(rulesIndex, params, checkArr)
          handleCancelRules()
        }
      } else {
        mappingManagementStore.onChangeRulesDataSource(rulesIndex, params, checkArr)
        handleCancelRules()
      }
    } else if (rulesType === 1) {
      mappingManagementStore.onChangePreFilter(this.state.filtersList)
      handleCancelRules()
      this.setState({
        filtersList: []
      })
    } else {
      mappingManagementStore.onChangeFilter(this.state.filtersList)
      handleCancelRules()
      this.setState({
        filtersList: []
      })
    }
    this.setState({
      editorState: ''
    })
    this.formRef.current.setFieldsValue({
      editorState: ''
    })
  }
  /*reset*/
  handleResetRules = () => {
    this.setState({
      filtersIndex: null
    })
    this.formRef.current.setFieldsValue({
      editorState: ''
    })
    this.setState({
      editorState: ''
    })
  }

  /*down filter list*/
  handleAddFilters = () => {
    const {mappingManagementStore, rulesType} = this.props
    const {inboundListRules, inboundListDefault, filtersDataSource, preProcessingDataSource} = mappingManagementStore
    const {filtersIndex} = this.state
    var params = []
    var checkParams = []
    var diffParams = []
    var checkArr = []
    var defaultFiltersList = []
    defaultFiltersList = rulesType === 1 ? preProcessingDataSource : rulesType === 2 ? filtersDataSource : null
    params = this.state.editorState
    if (!params.match(/^[ ]*$/)) {  /*not all empty*/
      if (params.match(/\$[\w|.//]+/g) !== null) {  /* do not exist fields list*/
        checkParams = JSON.parse(JSON.stringify(params.match(/\$[\w|//]+/g))?.replace(/\$/g, ''))
        checkParams.reduce((arr, item) => {
          !inboundListRules.includes(item) && diffParams.push(item)
          return diffParams
        }, [])
      }
      if (diffParams.length > 0) {
        alertMessage.error('Failed！The following fields do not exist![' + diffParams + ']')
      } else {
        for (let i = 0; i < checkParams.length; i++) {
          inboundListDefault.filter(item => item.path === checkParams[i]).map(it => {
            delete it.children
            return checkArr.push(it)
          })
        }
        if (filtersIndex !== null) {
          for (let i = 0; i < defaultFiltersList.length; i++) {
            if (i === filtersIndex && rulesType === 1) {
              defaultFiltersList[i].computationExpression = params
              defaultFiltersList[i].dependFields = checkArr
            } else if (i === filtersIndex && rulesType === 2) {
              defaultFiltersList[i].computationExpression = params
              defaultFiltersList[i].dependFields = checkArr
              defaultFiltersList[i].expression = true
              defaultFiltersList[i].filterAble = true
            }
          }
          this.setState({
            filtersList: defaultFiltersList
          })
        } else {
          if (rulesType === 1) {
            defaultFiltersList.push({computationExpression: params, dependFields: checkArr})
          } else {
            defaultFiltersList.push({computationExpression: params, dependFields: checkArr, expression: true, filterAble: true})
          }
          this.setState({
            filtersList: defaultFiltersList
          })
        }
        this.setState({
          editorState: '',
          filtersIndex: null
        })
      }
    } else {
      alertMessage.error('Failed！Please enter rules.')
    }
  }
  handleEditFilters = (item, index) => {
    this.formRef.current.setFieldsValue({
      editorState: item?.computationExpression,
    })
    this.setState({
      editorState: item?.computationExpression,
      filtersIndex: index
    })
  }
  handleDeleteFilters = (item, index) => {
    const {mappingManagementStore, rulesType} = this.props
    const {filtersDataSource, preProcessingDataSource} = mappingManagementStore
    var defaultFiltersList = []
    defaultFiltersList = rulesType === 1 ? preProcessingDataSource : rulesType === 2 ? filtersDataSource : null
    defaultFiltersList.splice(index, 1)
    if (this.state.filtersIndex === index) {
      this.formRef.current.setFieldsValue({
        editorState: ''
      })
    }
    this.setState({
      filtersList: defaultFiltersList,
      filtersIndex: null
    })
  }
  /*up filter list*/
  formulaClick = (explain, examples) => {
    const textArea = document.getElementById('textArea')
    textArea.value = examples // 修改文本框的内容
    textArea.select() // 选中文本
    try {
      //进行复制到剪切板
      if (document.execCommand('Copy', 'false', null)) {
        //如果复制成功
        console.log('Copy Success！')
      } else {
        //如果复制失败
        console.log('Copy Failed！')
      }
    } catch (err) {
      //如果报错
      console.log('Copy Error！')
    }
    $('.rulesUl .p1').text(explain)
    $('.rulesUl .p2').text(examples)
  }
  // formulaClick=(i,value)=>{
  //   const arr = [
  //     '\'value\'',
  //     '$apiPath',
  //     'date_format(to_timestamp($apiPath,\'yyyy-MM-dd\'),\'yyyyMMdd\')',
  //     'array($apiPath,$apiPath)',
  //     'sequence(1,size($apiPath))',
  //     'TRANSFORM($apiPath,x-> x)',
  //     'FILTER($apiPath,x -> x[\'referenceType\'] == \'CustPONO\')[0].referenceNumber',
  //     'date_format(to_timestamp(FILTER($apiPath,x -> x[\'type\'] == \'CustPODate\')[0].date,\'yyyyMMdd\'),\'yyyy-MM-dd\')',
  //     'cast($apiPath as double)',
  //     'TRANSFORM($apiPath,x -> IF(x[\'quantity\'][\'quantityType\'] == \'ConfirmedQTY\',cast(x[\'quantity\'][\'quantity\'] as double),null))',
  //     'concat($apiPath,$apiPath)',
  //     'case when $apiPath like \'value\' then concat($apiPath,\'value\') else concat($apiPath,\'value\') end',
  //     '$apiPath + $apiPath',
  //     '$apiPath - $apiPath',
  //     '$apiPath * $apiPath',
  //     '$apiPath / $apiPath',
  //     'round($apiPath*$apiPath,2)',
  //     'TRANSFORM($apiPath,x-> round(x[\'COST\']*x[\'PKGVOLUME\'],2))',
  //     'TRANSFORM($apiPath,x-> round(x[\'COST\']/1.13,2))',
  //     'external_table_lookup(\'value\',\'$apiPath == PG_HR_MD_MAPPING_CRV.VENDERID and $apiPath == PG_HR_MD_MAPPING_CRV.MD_DC_BH\',\'value\')"',
  //     'date_check($apiPath,\'YYYY-MM-dd\')',
  //     'value_check($apiPath,\'NUMBER\')',
  //     'regexp_replace($apiPath,\'value\',\'value\')',
  //
  //     '$apiPath == \'value\'',
  //     '$apiPath != \'value\'',
  //     '$apiPath > \'value\'',
  //     '$apiPath >= \'value\'',
  //     '$apiPath < \'value\'',
  //     '$apiPath <= \'value\'',
  //     'get_record_primary_key()',
  //     'AGGREGATE(Transform(x,y -> y),0,(acc,y) -> acc + cast(nvl(y[\'buyerNumberConv\'],0) as int))'
  //   ]
  //   const textArea = document.getElementById("textArea");
  //   textArea.value = arr[i]; // 修改文本框的内容
  //   textArea.select(); // 选中文本
  //   try{
  //     //进行复制到剪切板
  //     if(document.execCommand("Copy","false",null)){
  //       //如果复制成功
  //       console.log("Copy Success！");
  //     }else{
  //       //如果复制失败
  //       console.log("Copy Failed！");
  //     }
  //   }catch(err){
  //     //如果报错
  //     console.log("Copy Error！")
  //   }
  //   // $(`.rulesUl li:eq(${i})`).show().siblings().hide()
  //   $('.rulesUl .p1').text(this.state.defaultInfos[i].explain)
  //   $('.rulesUl .p2').text(this.state.defaultInfos[i].examples)
  // }
  /*tree select*/
  onSelect = (value) => {
    const textArea = document.getElementById('textArea')
    textArea.value = value.path // 修改文本框的内容
    textArea.select() // 选中文本
    try {
      //进行复制到剪切板
      if (document.execCommand('Copy', 'false', null)) {
        //如果复制成功
        console.log('Copy Success！')
      } else {
        //如果复制失败
        console.log('Copy Failed！')
      }
    } catch (err) {
      //如果报错
      console.log('Copy Error！')
    }
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {mappingManagementStore, addKeyModalVisible, handleCancelRules, rulesIndex, rulesType, t} = this.props
    const {inboundListTree, fieldDataSource, filtersDataSource, preProcessingDataSource, formulaInfos} = mappingManagementStore
    let _this = this
    return (
      <>
        <Modal
          title={rulesType === 1 ? t(`mappingManagement.preFilterRules`) : rulesType === 2 ? t(`mappingManagement.filterRules`) : t(`mappingManagement.conversionRules`)}
          closable={true}
          visible={addKeyModalVisible}
          // onOk={this.handleOk}
          onCancel={handleCancelRules}
          maskClosable={false}
          destroyOnClose={true}
          width="70%"
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancelRules}>{t(`general.cancel`)}</Button>,
            <Button key="Reset" onClick={this.handleResetRules}>{t(`general.reset`)}</Button>,
          ]}
          className="mappingTreeTable"
        >
          {rulesIndex !== '' ?
            <div><span style={{
              fontSize: 16,
              fontWeight: 'bold'
            }}>{t(`mappingManagement.outboundFieldName`)}: </span>{fieldDataSource[rulesIndex]?.fieldInfo?.path}
            </div> : null}
          <Form ref={this.formRef} key="addRules">
            <Row style={{border: '1px solid #f0eff3'}}>
              <Col span={7}>
                {/*<Tree*/}
                {/*  // showLine*/}
                {/*  // switcherIcon={<MinusOutlined  />}*/}
                {/*  onSelect={this.onSelect}*/}
                {/*  titleRender={(item)=>{ return item.key}}*/}
                {/*  treeData={inboundListTree}*/}
                {/*  style={{height: 180, border: '1px solid #d9d9d9', overflowY: 'scroll'}}*/}
                {/*/>*/}
                <Table rowKey="path" rowClassName={this.getRowClassName} dataSource={toJS(inboundListTree)} defaultExpandAllRows={true}
                       pagination={false} indentSize={30} scroll={{y: 450}} style={{height: 501, border: 'none'}}
                       onRow={record => {
                         return {
                           onClick: event => { this.onSelect(record)}, // 点击行
                         }
                       }}>
                  <Table.Column title={t(`mappingManagement.fieldName`)} dataIndex="name" key="name" ellipsis={true}/>
                  <Table.Column width={100} title={t(`mappingManagement.fieldType`)} dataIndex="fieldType" key="fieldType"/>
                </Table>
              </Col>
              <Col span={10}>
                <Row>
                  <Col span={24} style={{position: 'relative', zIndex: 1, borderBottom: '1px solid #f0eff3'}} className="rulesBtn">
                    <TextArea id="textArea" rows={4} style={{position: 'fixed', left: -20000}}/>
                    <Form.Item name="editorState" label="">
                      <TextArea onChange={this.handleChange} placeholder={t(`general.pleaseEnter`)} className="my-editor" style={{
                        border: 'none',
                        height: rulesIndex !== '' ? 296 : 100,
                        borderRadius: 0,
                        resize: 'none'
                      }}/>
                    </Form.Item>
                    {rulesIndex !== '' ? null : <Button type="primary" onClick={this.handleAddFilters} style={{
                      position: 'absolute',
                      right: 5,
                      bottom: 5,
                      lineHeight: '12px',
                      zIndex: 2
                    }}>{t(`general.save`)}</Button>}
                  </Col>
                  {rulesIndex !== '' ? null : <Col span={24} style={{borderBottom: '1px solid #f0eff3'}}>
                    <List
                      // header={<div>Filter List</div>}
                      style={{height: 196, overflowY: 'scroll'}}
                      dataSource={rulesType === 1 ? preProcessingDataSource : filtersDataSource}
                      renderItem={(item, index) => (
                        <List.Item actions={[<Button type="link" style={{lineHeight: '12px'}}
                                                     onClick={() => this.handleEditFilters(item, index)}>{t(`general.edit`)}</Button>,
                          <Button type="link" style={{lineHeight: '12px'}}
                                  onClick={() => this.handleDeleteFilters(item, index)}>{t(`general.delete`)}</Button>]}>
                          {item?.computationExpression}
                        </List.Item>
                      )}
                    />
                  </Col>}
                  <Col span={24}>
                    <div className="rulesUl">
                      {/*<h3>Constant Value</h3>*/}
                      <h4>{t(`mappingManagement.explain`)}：</h4>
                      <p className="p1" style={{minHeight: 24}}>
                        {/*{this.state.defaultInfos[0].explain}*/}
                      </p>
                      <h4>{t(`mappingManagement.examples`)}：</h4>
                      <p className="p2" style={{whiteSpace: 'pre-line'}}>
                        {/*{this.state.defaultInfos[0].examples}*/}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={7} className="rulesBtn">
                <Collapse defaultActiveKey={[]} ghost>
                  {
                    formulaInfos.map(function (formulaType, formulaTypeIndex) {
                      let {formulaInfoList} = formulaType
                      return (
                        <Panel header={formulaType.name} key={'formulaType_' + formulaTypeIndex}>
                          {
                            formulaInfoList && formulaInfoList.map(function (formulaInfo, formulaInfoIndex) {
                              return (
                                <Button type="primary" onClick={() => _this.formulaClick(formulaInfo.description, formulaInfo.examples)}
                                        key={'formulaInfo_' + formulaInfoIndex}>{formulaInfo.name}</Button>
                              )
                            })
                          }
                        </Panel>
                      )
                    })
                  }
                </Collapse>
                {/*<Collapse defaultActiveKey={[]} ghost>*/}
                {/*  <Panel header="Math Function" key="1">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(12)}>addition</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(13)}>Minus</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(14)}>multiplication</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(15)}>division</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(16)}>round</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Text Function" key="2">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(10)}>concat</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Conversion Function" key="3">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(5)}>Transform</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(8)}>Type Transformation</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Date function" key="4">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(2)}>Date formation</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Constant Function" key="5">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(0)}>Constant Value</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Assignment Function" key="6">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(1)}>Assignment Directly</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="LOOKUP Function" key="7">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(19)}>Lookup</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Replace Function" key="8">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(22)}>Replace</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Filter Function" key="9">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(6)}>Filter</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Check Function" key="10">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(20)}>Date check</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(21)}>Value check</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Conditional Function" key="11">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(11)}>Case when (IF ELSE)</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="BuildArray" key="12">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(3)}>Build Array</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Get Item Number" key="13">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(4)}>Get Item Number</Button>*/}
                {/*  </Panel>*/}
                {/*  <Panel header="Combination Functions" key="14">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(7)}>Date Formation + Filter</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(9)}>Transform+IF+cast</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(17)}>Transform+multiplication</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(18)}>Transform+division</Button>*/}
                {/*  </Panel>*/}
                {/*  {rulesIndex===''?*/}
                {/*      <Panel header="Operator" key="15">*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(23,'==')}>=</Button>*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(24,'!=')}>!=</Button>*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(25,'&gt;')}>&gt;</Button>*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(26,'&gt;=')}>&gt;=</Button>*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(27,'&lt;')}>&lt;</Button>*/}
                {/*        <Button type='primary' onClick={() =>this.formulaClick(28,'=&lt;')}>&lt;=</Button>*/}
                {/*      </Panel>*/}
                {/*      :null}*/}
                {/*  <Panel header="Other" key="16">*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(29)}>Get Record Primary Key</Button>*/}
                {/*    <Button type='primary' onClick={() =>this.formulaClick(30)}>AGGREGATE</Button>*/}
                {/*  </Panel>*/}
                {/*</Collapse>*/}
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModalRules)
